module.exports = __webpack_public_path__ + "static/media/hangers.e0ee64b4.svg";